import { createElement } from "react";
import { withApollo } from "../../graphql/client";
import EnableMyShopSwitch from "./EnableMyShopSwitch";

export default function (props, _context) {
  return function EnableMyShopSwitchApp() {
    return withApollo(createElement(EnableMyShopSwitch, props));
  };
}
